import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Chat, IMessengerConnector, Message} from '../../../types/all.type';
import {SenderService} from '../../../services/sender.service';
import {IMessage} from '../../../services/websocket';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import {log} from '../../../functions';
import {from, ReplaySubject, Subject} from 'rxjs';
import {InterfaceService} from '../../../services/interface.service';
import {AllService} from '../../../services/all.service';
import {ContextMenuComponent, ContextMenuService} from 'ngx-contextmenu';
import {AppService} from '../../../services/app.service';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';

@Component({
  selector: 'app-chat-item',
  templateUrl: './chat-item.component.html',
  styleUrls: ['./chat-item.component.scss']
})
export class ChatItemComponent implements OnInit, OnDestroy {
  @Input() chat: Chat;
  @Input() index: number;
  @Input() Service: IMessengerConnector;
  @Input() contextMenu: ContextMenuComponent;
  private destroy$: Subject<void> = new Subject();
  detectChanges$: ReplaySubject<string> = new ReplaySubject();
  constructor(
    public allMessengersService: AllMessengersService,
    public appService: AppService,
    public contextMenuService: ContextMenuService,
    public cd: ChangeDetectorRef,
    public allService: AllService,
    public interfaceService: InterfaceService,
    public senderService: SenderService
  ) { }

  ngOnInit(): void {
    this.allService.wsService.on<IMessage>('online')
      .pipe(takeUntil(this.destroy$), filter((data) =>
        this.chat.service_type === data.path && this.chat.id === data.user_id)
      )
      .subscribe((data) => {
        this.chat.online = data?.online;
        if (!this.chat.online) {
          this.chat.typing = false;
        }
        this.chat.last_seen = data?.last_seen;
        this.detectChanges$.next('online');
      });
    this.allService.wsService.on<IMessage>('typing')
      .pipe(takeUntil(this.destroy$), filter((data) =>
        this.chat.service_type === data.path && this.chat.id === data.user_id)
      )
      .subscribe((data) => {
        this.chat.typing = true;
        setTimeout(() => {
          this.chat.typing = false;
          this.detectChanges$.next('typing');
        }, 5000);
        this.detectChanges$.next('typing end');
      });


    this.allService.wsService.on<IMessage>('edit_message')
      .pipe(takeUntil(this.destroy$), filter((data) =>
        this.chat.service_type === data.path && this.chat.id === data.edit_message.chat_id
      ))
      .subscribe((data) => {
        const updateChat = (v) => {
          if (v) {
            v.last_message.text = data.edit_message.text;
            v.last_message.text_list = data.edit_message.text_list;
            v.last_message.edit_date = data.edit_message.edit_date;
          }
        };
        updateChat(this.chat);
        this.detectChanges$.next('edit_message');
      });
    this.interfaceService.toggleChatPine$
      .pipe(takeUntil(this.destroy$), filter(v =>
        this.chat.service_type === v.service_type && this.chat.id === v.id
      )).subscribe((message) => {
      this.cd.detectChanges();
    });

    this.allService.wsService.on<IMessage>('delete_messages')
      .pipe(takeUntil(this.destroy$), filter((data) =>
        this.chat.service_type === data.path && data.delete_messages.includes(this.chat?.last_message?.id)
      ))
      .subscribe((data) => {
        this.chat.last_message.delete = true;
        this.detectChanges$.next('delete_messages');
      });

    this.allService.newMessage$
      .pipe(takeUntil(this.destroy$), filter(v =>
        this.chat.service_type === v.service_class && !!v && v.chat_id === this.chat.id
      ))
      .subscribe((message) => {
        this.onNewMessage(message);
      });
    this.allService.wsService.on<IMessage>('new_message')
      .pipe(takeUntil(this.destroy$), filter((v) =>
        this.chat.service_type === v.path && this.chat.id === v.new_message?.chat_id
      ))
      .subscribe((data) => {
        this.onNewMessage(data.new_message);
      });
    this.interfaceService.openChat$.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe((event) => {
      this.detectChanges('openChat$');
    });


    this.detectChanges$.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe((text) => {
      this.detectChanges('$ ' + text);
    });

  }
  onNewMessage(message: Message) {
    this.chat.typing = false;
    this.chat.last_message = message;
    if (!this.chat.last_message.out) {
      this.chat.unread_messages_count++;
    } else {
      this.chat.unread_messages_count = 0;
    }
    this.detectChanges('$onNewMessage');
  }

  detectChanges(text: string): void {
    log('ChatItemComponent detectChanges', text, new Date().getSeconds());
    this.cd.detectChanges();
  }
  openChat(chat: Chat) {
    if (chat.service_type) {
      this.appService.openChat(chat, chat.service_type);
      this.chat.unread_messages_count = 0;
      this.allService.saveLocalChats$.next();
      this.detectChanges$.next('openChat');
    } else {
      alert('chat.service_type not found');
    }
  }
  public contextMenuOpen($event, item: Chat): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.contextMenu,
      event: $event as any,
      item
    });
    $event.preventDefault();
    $event.stopPropagation();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
